<template>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />
        <div class="">
            <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <p class="text-center text-sm font-semibold uppercase text-gray-500 tracking-wide">
                    <!-- Trusted by -->
                </p>
                <div class="mt-6 grid grid-cols-1 gap-1 md:grid-cols-1">
                    <p style="font-weight: bold;">Помощь и поддержка по заболеваниям печени:</p>
                    <p><a style="color: blue;" href="https://gepatitu.net">https://gepatitu.net</a> </p>
                </div>
                <div class="mt-6 grid grid-cols-1 gap-1 md:grid-cols-1">
                    <p style="font-weight: bold;">Телефон горячей линии:</p>
                    <p><a style="color: blue;" href="tel: 88007751996">8 (800) 775-19-96</a></p>
                    <p>(бесплатно из любого региона России)</p>
                </div>
                <div class="mt-6 grid grid-cols-1 gap-1 md:grid-cols-1">
                    <p style="font-weight: bold;">Техническая поддержка:</p>
                    <p><a style="color: blue;" href="mailto:admin@gepatitu.net">admin@gepatitu.net</a> </p>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
export default {
    data() {
        return {
            title: 'Помощь'
        }
    },
    components: {
        PageTitle,
    }
}
</script>